<template>
  <div>
    <AlertDismiss ref="alertDismiss"></AlertDismiss>

    <b-form @submit="onSubmit">
      <b-form-group
        class="mb-3"
        id="input-group-name"
        label="Correo electrónico"
      >
        <b-form-input
          id="input-name"
          v-model="form.email"
          type="email"
          placeholder="Ejemplo@dominio.com"
          required
        ></b-form-input>
      </b-form-group>

      <PasswordInput class="mb-3" v-model="form.password"></PasswordInput>

      <div class="d-flex justify-content-between align-items-center">
        <div>
          <b-button
            class="me-2"
            type="submit"
            variant="primary"
            :disabled="process"
          >
            <b-spinner v-if="process" small />
            Ingresar
          </b-button>

          <b-button
            variant="outline-secondary"
            :to="{ name: 'DenounceAnonymous' }"
          >
            Realizar Denuncia
          </b-button>
        </div>

        <a
          href="#"
          @click.prevent="forgotPassword"
          class="text-decoration-none small"
        >
          ¿Olvidó su contraseña?
        </a>
      </div>
    </b-form>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import {
  create as createItemLocal,
  localStorageKey,
  remove as removeItemLocal,
} from "@/plugins/localStorage/index.js";
import { decrypt as decryptToken } from "@/plugins/JWT/index.js";
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";
import PasswordInput from "@/components/shared/Password-input.vue";

export default {
  name: "LoginForm",

  data() {
    return {
      form: {
        email: "",
        password: "",
      },

      process: false,
    };
  },

  components: {
    AlertDismiss,
    PasswordInput,
  },

  methods: {
    ...mapActions(["login", "getUserById", "storePermissions"]),
    ...mapMutations(["modifySession", "modifyPermissions", "modifyRole"]),

    async onSubmit(event) {
      this.processing();

      event.preventDefault();

      let result = await this.loginUser();
      if (result == null) {
        return;
      }

      // Check if OTP is required
      if (result.data.requiresOtp) {
        this.processing();
        this.$emit("requireOtp", this.form.email, this.form.password);
        return;
      }

      // If JWT is provided and no OTP required, proceed with normal flow
      if (result.data.jwt) {
        let tokenResult = this.generateToken({ data: result.data.jwt });
        if (tokenResult == null) {
          return;
        }

        this.storeSession(tokenResult);

        let user = await this.getUser(tokenResult);
        if (user == null) {
          return;
        }

        var permisos = this.obtenerPermisosUnicos(user);
        this.storePermissions(permisos);

        this.storeRole(user.roles[0].name);

        this.processing();

        this.$emit("goHome");
      }
    },

    async loginUser() {
      let result = await this.login({
        mail: this.form.email,
        password: this.form.password,
      });

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        this.processing();
        return null;
      }

      return result;
    },

    generateToken(result) {
      createItemLocal(localStorageKey.tokenKey, result.data);

      let tokenResult = decryptToken(result.data);
      if (tokenResult.isError) {
        this.$refs.alertDismiss.showAlert(tokenResult.message);
        removeItemLocal(localStorageKey.tokenKey);
        this.processing();
        return null;
      }

      return tokenResult;
    },

    storeSession(tokenResult) {
      this.modifySession({
        userId: tokenResult.data.UserId,
        username: tokenResult.data.Username,
        mail: tokenResult.data.mail,
        exp: tokenResult.data.exp,
      });
    },

    async getUser(tokenResult) {
      let result = await this.getUserById({ id: tokenResult.data.UserId });

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        this.processing();
        return null;
      }

      return result.data;
    },

    obtenerPermisosUnicos(usuario) {
      const permisos = new Set(); //el Set permite que no se dupliquen

      usuario.roles.forEach((role) => {
        role.permissions.forEach((permiso) => {
          permisos.add(permiso);
        });
      });

      return Array.from(permisos); // Convertir el Set de vuelta a un array si es necesario
    },

    storePermissions(permisos) {
      let names = permisos.map((x) => {
        return x.name;
      });

      if (names.length === 0) {
        names = ["default-sin-permisos"];
      }

      this.modifyPermissions(names);
      createItemLocal(localStorageKey.permissionKey, names);
    },

    storeRole(role) {
      this.modifyRole(role);
      createItemLocal(localStorageKey.roleKey, role);
    },

    onReset(event) {
      event.preventDefault();

      this.form.email = "";
      this.form.password = "";
    },

    processing() {
      this.process = !this.process;
    },

    forgotPassword() {
      this.$emit("forgotPassword");
    },
  },
};
</script>
